import consumer from "./consumer"

function chatDocIsAudioLocal(doc) {
    if (!doc || !doc.url) return false;
    const ct = (doc.content_type || '').toLowerCase();
    const url = (doc.url || '').toLowerCase();
    const name = (doc.filename || '').toLowerCase();
    if (ct.indexOf('audio') >= 0) return true;
    const blob = [url, name].join(' ');
    return /\.(webm|m4a|mp3|ogg|wav|aac)(\?|$)/.test(blob) || blob.indexOf('voice-message') >= 0;
}

function buildChatAudioHtmlLocal(doc) {
    const ct = doc.content_type || 'audio/webm';
    return '<div class="chat-audio-msg"><div class="chat-voice-bubble">' +
        '<i class="fa fa-microphone" aria-hidden="true"></i>' +
        '<audio controls preload="metadata"><source src="' + doc.url + '" type="' + ct + '"></audio>' +
        '</div></div>';
}

window.chatMessageTextHtml = function(msg) {
    let text = (msg || '').trim();
    if (!text) return '';
    
    // Escape HTML to prevent XSS (matching server-side ERB::Util.html_escape)
    text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    
    // Parse @mentions dynamically using the global group members list
    if (window.currentGroupMembersList && window.currentGroupMembersList.length > 0) {
        window.currentGroupMembersList.forEach(user => {
            if (user.name) {
                const escapedName = user.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp('@' + escapedName, 'g');
                
                if (regex.test(text)) {
                    const userId = user.id || user.user_id || '';
                    const safeName = user.name.replace(/"/g, '&quot;');
                    const safePhone = (user.phone || '').replace(/"/g, '&quot;');
                    const safeDp = (user.dpUrl || '/assets/landing_page/user1.webp').replace(/"/g, '&quot;');
                    
                    const spanHtml = `<span class="mention-tag-msg" data-user-id="${userId}" data-user-name="${safeName}" data-user-phone="${safePhone}" data-user-dp="${safeDp}" style="color: #007bff; cursor: pointer; font-weight: 600;">@${user.name}</span>`;
                    
                    text = text.replace(regex, spanHtml);
                }
            }
        });
    }
    
    return '<p>' + text + '</p>';
}

function normalizeChatMessageDocs(messageData) {
    if (!messageData || messageData.document == null || messageData.document === undefined) return [];
    const docs = messageData.document;
    return Array.isArray(docs) ? docs : [docs];
}

function chatSidebarDocName(doc) {
    if (!doc) return '';
    if (typeof doc === 'string') return doc;
    let name = (doc.filename || doc.name || doc.file_name || '').trim();
    if (!name && doc.url) {
        name = doc.url.split('/').pop().split('?')[0];
        try { name = decodeURIComponent(name); } catch (e) { }
    }
    return name;
}

function chatSidebarDocLabel(docs) {
    if (!docs || !docs.length) return '';
    const names = docs.map(chatSidebarDocName).filter(Boolean);
    if (!names.length) return '';
    let label = names[0];
    if (names.length > 1) label += ' (+' + (names.length - 1) + ')';
    return label;
}

function chatSidebarMessageBody(messageData, fallbackDocs) {
    if (!messageData) messageData = {};
    const text = (messageData.msg || '').trim();
    if (text) return text;
    let docs = normalizeChatMessageDocs(messageData);
    if (!docs.length && fallbackDocs && fallbackDocs.length) docs = fallbackDocs;
    return chatSidebarDocLabel(docs);
}

function formatChatSidebarPreview(messageData, currentUserId, senderName, masked, fallbackDocs) {
    // If the message was deleted, always show the deleted placeholder
    if (messageData && (messageData.is_deleted === true || messageData.is_deleted === 'true')) {
        return '<em style="color:#999;">This message was deleted</em>';
    }

    const body = chatSidebarMessageBody(messageData, fallbackDocs);
    if (!body) return '';

    if (masked) {
        return '*** ' + body;
    }

    const senderId = parseInt(messageData.sender_id, 10);
    if (senderId === parseInt(currentUserId, 10)) {
        return 'You: ' + body;
    }
    if (senderName) {
        return senderName + ' : ' + body;
    }
    return body;
}

function updateChatSidebarPreview(roomId, messageData, currentUserId, senderName, fallbackDocs) {
    if (!roomId) return;
    const roomKey = String(roomId);
    const pending = (window._pendingChatSidebarDocs || {})[roomKey];
    const docs = fallbackDocs || pending || null;
    const preview = formatChatSidebarPreview(messageData, currentUserId, senderName, false, docs);
    if (!preview) return;
    $('#latest_new_msg_' + roomKey).html(preview);
    if (window._pendingChatSidebarDocs && window._pendingChatSidebarDocs[roomKey]) {
        delete window._pendingChatSidebarDocs[roomKey];
    }
}

window.formatChatSidebarPreview = formatChatSidebarPreview;
window.updateChatSidebarPreview = updateChatSidebarPreview;

function isActiveMessagesChat(roomId, senderId, receiverId, groupChat, currentUserId) {
    const activeRoomId = parseInt($('#live-mes-room-id').val(), 10);
    const parsedRoomId = parseInt(roomId, 10);
    if (!isNaN(activeRoomId) && !isNaN(parsedRoomId)) {
        return activeRoomId === parsedRoomId;
    }

    const activeService = $('.user-live-message.active').data('service');
    if (activeService !== undefined && activeService !== null && String(activeService).trim() !== '') {
        const parsedService = parseInt(activeService, 10);
        if (!isNaN(parsedService) && !isNaN(parsedRoomId)) {
            return parsedService === parsedRoomId;
        }
        return String(activeService) === String(roomId);
    }

    return false;
}

function buildChatDocHtmlFromData(docData) {
    if (!docData || !docData.length) return '';
    if (window.buildChatDocAttachmentHtml) {
        let html = '<div class="chat-grp-img">';
        for (let i = 0; i < docData.length; i++) {
            html += window.buildChatDocAttachmentHtml(docData[i]);
        }
        return html + '</div>';
    }
    let html = '<div class="chat-grp-img">';
    for (let i = 0; i < docData.length; i++) {
        const doc = docData[i];
        const ct = (doc.content_type || '').toLowerCase();
        if (ct.indexOf('image') >= 0) {
            html += '<a href="' + doc.url + '" target="_blank" title="View image"><img srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-srcset="' + doc.url + '" alt="img" class="lazyload"></a>';
        } else if (chatDocIsAudioLocal(doc)) {
            html += buildChatAudioHtmlLocal(doc);
        } else if (ct.indexOf('pdf') >= 0 || ct.indexOf('application') >= 0) {
            html += '<a href="' + doc.url + '" target="_blank" title="Read pdf"><img srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-srcset="/assets/img_icon.png" alt="pdf" class="lazyload"></a>';
        } else if (ct.indexOf('video') >= 0) {
            html += '<a href="' + doc.url + '" target="_blank" title="Watch Video"><video class="lazyload" controls><source src="' + doc.url + '" type="' + doc.content_type + '"></video></a>';
        }
    }
    return html + '</div>';
}

let current_user
let receiver_user
let count_user
let receiver_user_message
let receiver_room_id
let receiver_box_id
let hasAutoClickedFirstToast = false;

let unreadFetchedOnLoad = false;
function applyUnreadCount(count) {
    if (count > 0) {
        $('#nav-msg-count').text(count);
        $("#live-msg").removeClass("d-block").addClass("d-none");
        $("#msg").removeClass("d-none").addClass("d-block");
    } else {
        $('#nav-msg-count').text('');
    }
}

consumer.subscriptions.create("ChatChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        current_user = $('#current_user_id').val();
        if (current_user !== "" && current_user !== "undefined" && current_user !== undefined) {
            const cached = localStorage.getItem('unread_msg_count_' + current_user);
            if (cached !== null) {
                const count = parseInt(cached) || 0;
                applyUnreadCount(count);
            } else {
                // Cache was invalidated (e.g. user saw messages) or first visit — fetch fresh count from server
            $.ajax({
                type: 'GET',
                url: '/latest_message_count',
                success: function (data) {
                    const count = data.data.unread_message || 0;
                    localStorage.setItem('unread_msg_count_' + current_user, count);
                    applyUnreadCount(count);
                    }
            });
                }
        }
    },
    disconnected() {
        // Called when the subscription has been terminated by the server
    },
    received(data) {
        console.log(data, "data")
        if (current_user !== "" && current_user !== "undefined" && current_user !== undefined) {
            // Handle real-time edit/delete broadcasts
            if (data.content && data.content.action === 'edit') {
                let msgId = data.content.id;
                $('[data-msg-id="' + msgId + '"] .chat-message > p').text(data.content.msg);
                $('[data-msg-id="' + msgId + '"] .msg-edited-badge').remove();
                $('[data-msg-id="' + msgId + '"] .chat-message > p').after('<span class="msg-edited-badge"> (edited)</span>');
                return;
            }
            if (data.content && data.content.action === 'delete') {
                let msgId = data.content.id;
                let docUrls = data.content.doc_urls || [];
                if (window.removeFromGroupInfoMediaFiles) {
                    window.removeFromGroupInfoMediaFiles(docUrls, msgId);
                }
                let $msgCell = $('[data-msg-id="' + msgId + '"]');
                let $chatMessage = $msgCell.find('.chat-message');
                if ($chatMessage.find('> p').length === 0) {
                    $chatMessage.prepend('<p></p>');
                }
                $chatMessage.find('> p').html('<em>This message was deleted</em>').addClass('deleted-msg-text').show();
                $msgCell.find('.chat-body').removeClass('emoji-only-msg');
                $msgCell.find('.msg-edited-badge, .msg-edit-delete-actions, .chat-grp-img').remove();

                // Update sidebar preview if this deleted message is the latest shown there
                let deletedChatboxId = data.content.chatbox_id;
                if (deletedChatboxId) {
                    let $sidebarEntry = $('.user-live-message[data-service="' + deletedChatboxId + '"]');
                    if ($sidebarEntry.length && String($sidebarEntry.attr('data-msg-id')) === String(msgId)) {
                        $('#latest_new_msg_' + deletedChatboxId).html('<em>This message was deleted</em>').css('color', '#999');
                    }
                }

                return;
            }
            if (data.content && data.content.action === 'seen') {
                let msgId = data.content.id;
                let chatboxId = data.content.chatbox_id;
                let activeRoomId = parseInt($('#live-mes-room-id').val());
                if (chatboxId === activeRoomId) {
                    if (window.setChatReadTicks) {
                        window.setChatReadTicks($('[data-msg-id="' + msgId + '"] .msg-status-ticks'), true);
                    }
                }
                return;
            }
            if (data.content && data.content.action === 'room_seen') {
                let chatboxId = data.content.chatbox_id;
                let activeRoomId = parseInt($('#live-mes-room-id').val());
                let readerId = data.content.reader_id;
                if (parseInt(readerId) === parseInt(current_user)) {
                    let $roomBadge = $(`.unread-count-badge[data-chatbox-id="${chatboxId}"]`);
                    let roomUnread = parseInt($roomBadge.text()) || 0;
                    $roomBadge.text('0').hide();
                    if (roomUnread > 0) {
                        let navVal = parseInt($('#nav-msg-count').text()) || 0;
                        let newVal = Math.max(0, navVal - roomUnread);
                        $('#nav-msg-count').text(newVal > 0 ? newVal : '');
                    }
                    // Invalidate localStorage so the next page reload will fetch fresh updated count from API
                    localStorage.removeItem('unread_msg_count_' + current_user);
                }
                if (chatboxId === activeRoomId) {
                    if (window.setChatReadTicks) {
                        $('[data-msg-id] .msg-status-ticks').each(function () {
                            window.setChatReadTicks($(this), true);
                        });
                    }
                }
                return;
            }
            receiver_user = $('#live-chat-receiver-user-id').val();
            receiver_user_message = $('#live-mes-receiver-id').val();
            receiver_room_id = parseInt($('#live-mes-room-id').val());
            receiver_box_id = parseInt($('#live-chat-room-id').val());
            count_user = $('.chatUserId').map(function () { return this.id; }).get();
            let receiver = data.content.receiver_id;
            let sender = data.content.sender_id;
            let msg = data.content.msg;
            let docData = data.content.document
            let client_hide = data.content.client_hide;
            let employees = data.content.employees;
            let client = data.content.client;
            let room_id = data.content.chatbox_id;
            let group_chat = data.content.group_chat;
            let receptient = data.content.receptient;
            let id = data.content.id;
            let sender_name = data.content.sender

            // Prevent receiving messages if user was removed from the group (not in receptient)
            if (group_chat && Array.isArray(receptient)) {
                if (!receptient.includes(parseInt(current_user)) && parseInt(sender) !== parseInt(current_user)) {
                    return;
                }
            } else if (!group_chat) {
                if (parseInt(receiver) !== parseInt(current_user) && parseInt(sender) !== parseInt(current_user)) {
                    return;
                }
            }

            // Update sidebar preview immediately (before any code that might throw)
            var sidebarUpdater = window.updateChatSidebarPreview || updateChatSidebarPreview;
            let chatItem = $(`.user-live-message[data-service='${room_id}']`);
            if (chatItem.length > 0) {
                sidebarUpdater(room_id, data.content, current_user, sender_name);
                chatItem.attr('data-msg-id', id);
                chatItem.prependTo('.sidebar-chat-list');
                if (window.updateChatSidebarTime) {
                    window.updateChatSidebarTime(room_id, data.content.created_at);
                }
            } else if (parseInt(sender) !== parseInt(current_user)) {
                // New chat from another user — dynamically add a sidebar entry
                // so the receiver doesn't need to refresh the page
                let isOnMessagesPage = $('#sidebar-chat-list').length > 0;
                if (isOnMessagesPage && $(`#sidebar-chat-list .user-live-message[data-service='${room_id}']`).length === 0) {
                    let dpUrl = (data.content.dp_sender && data.content.dp_sender.url) ? data.content.dp_sender.url : '/images/default.webp';
                    let isGroup = !!group_chat;
                    // For group chats, show the group name; for direct chats, show the sender name
                    let displayName = (isGroup && data.content.group_name) ? data.content.group_name : (sender_name || 'User');
                    let previewText = formatChatSidebarPreview(data.content, current_user, sender_name, false);
                    const formatTs = window.formatTimestamp || function (ds) { return ds; };
                    let timeDisplay = data.content.created_at ? formatTs(data.content.created_at) : '';

                    // Build role badge HTML for group chats
                    let badgeHtml = '';
                    if (isGroup) {
                        badgeHtml = '<span class="chat-role-badges"><span class="chat-role-badge chat-role-badge--employee">Employee (Group)</span></span>';
                    }

                    let newChatHtml = `<a class="user-live-message d-flex" data="${isGroup ? '' : sender}" data-service="${room_id}" data-type="${isGroup ? 'group' : 'direct'}" data-chat-employee="${isGroup ? 'true' : 'false'}" data-chat-client="false" data-chat-provider="false" data-msg-id="${id}" style="padding: 12px 15px; border-radius: 8px; cursor: pointer; text-decoration: none; color: inherit; transition: background 0.2s; margin-bottom: 5px;">
                      <div style="position: relative; margin-right: 15px;">
                        <img src="${dpUrl}" style="width: 45px !important; height: 45px; border-radius: 50%; object-fit: cover; min-width: 45px;" alt="Avtar">
                      </div>
                      <div style="flex-grow: 1; min-width: 0;">
                        <div class="d-flex justify-content-between align-items-baseline mb-1">
                          <div class="d-flex align-items-center" style="min-width: 0; flex: 1;">
                            <h4 style="font-size: 15px; font-weight: 600; color: #222; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${displayName}</h4>
                            ${badgeHtml}
                          </div>
                          <span class="chat-sidebar-time" style="font-size: 11px; color: #888; flex-shrink: 0;">${timeDisplay}</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                          <p id="latest_new_msg_${room_id}" style="font-size: 13px; color: #666; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 90%;">${previewText || 'Tap to send message'}</p>
                          <span class="unread-count-badge" data-chatbox-id="${room_id}" style="background: #E86C2E; color: white; font-size: 10px; font-weight: 700; height: 18px; min-width: 18px; border-radius: 9px; display: none; align-items: center; justify-content: center; padding: 0 5px; flex-shrink: 0; margin-left: 8px;">0</span>
                        </div>
                      </div>
                    </a>`;

                    // Remove "no chat available" placeholder if present
                    $('#sidebar-chat-list .text-muted').remove();
                    $('#sidebar-chat-list').prepend(newChatHtml);
                }
            }

            let unread_message = data.content.unread_message
            let dp_sender = (data.content.dp_sender && data.content.dp_sender.url) ? data.content.dp_sender.url : null
            let group_chat_recipients = data.content.count_chat_user
            let created_at = data.content.created_at
            let sender_img = '';
            let sender_user = '';

            const formatTimestamp = window.formatTimestamp || function (ds) { return ds; };
            let formattedTime = formatTimestamp(created_at);
            const msgDateKey = window.chatDatePartsInZone ? window.chatDatePartsInZone(created_at).dateKey : '';

            if (dp_sender == null) {
                sender_img = "/images/default.webp";
            } else {
                sender_img = dp_sender;
            }
            if (sender_name == null || sender_name === "") {
                sender_user = "user"
            } else {
                sender_user = sender_name
            }

            $('.chat-box-live').filter(function () {
                return $(this).css('display') === 'block';
            }).each(function () {
                if (sender === parseInt(current_user)) {
                    // Append the latest message to the chat window
                    let documentStr = buildChatDocHtmlFromData(docData);
                    let lastSenderId = null;
                    let $lastMsg = $('.live-chat-body td[data-sender-id], .append-chat-live li[data-sender-id]').last();
                    if ($lastMsg.length > 0) {
                        lastSenderId = parseInt($lastMsg.attr('data-sender-id'));
                    }
                    let nameHeader = (lastSenderId !== sender) ? "<h5>You</h5>" : "";

                    if (window.maybePrependChatDateSeparator) {
                        window.maybePrependChatDateSeparator(created_at, '.append-chat-live');
                    }
                    let str = "<li class=\"out\" data-sender-id=\"" + sender + "\" data-msg-date=\"" + msgDateKey + "\"><div class=\"chat-img\"><img alt=\"Avtar\" class=\"live-chat-img\" src=\"" + sender_img + "\"></div>" +
                        "<div class=\"chat-body\"><div class=\"chat-message\">" + nameHeader +
                        window.chatMessageTextHtml(msg) + documentStr + "<div class=\"chat-timestamp\">" + formattedTime + "</div></div></div></li>"
                    $(".append-chat-live").append(str)
                    $(".live-chat-user-msg").focus();
                    $('.live-chat-body').stop().animate({
                        scrollTop: $(".chat")[0].scrollHeight
                    });
                }
            });
            if (!(sender === parseInt(current_user)) && (receiver_box_id === room_id)) {
                let documentStr = buildChatDocHtmlFromData(docData);
                if (client_hide != null && !client_hide.includes(current_user.toString()) && employees.includes(parseInt(current_user)) && sender == client) {
                    sender_user = "***"
                }
                let lastSenderId = null;
                let $lastMsg = $('.live-chat-body td[data-sender-id], .append-chat-live li[data-sender-id]').last();
                if ($lastMsg.length > 0) {
                    lastSenderId = parseInt($lastMsg.attr('data-sender-id'));
                }
                let nameHeader = (lastSenderId !== sender) ? "<h5>" + sender_user + "</h5>" : "";

                if (window.maybePrependChatDateSeparator) {
                    window.maybePrependChatDateSeparator(created_at, '.append-chat-live');
                }
                let str = "<li class=\"in\" data-sender-id=\"" + sender + "\" data-msg-date=\"" + msgDateKey + "\"><div class=\"chat-img\"><img alt=\"Avtar\" class=\"live-chat-img\" src=\"" + sender_img + "\"></div>" +
                    "<div class=\"chat-body\"><div class=\"chat-message\">" + nameHeader +
                    window.chatMessageTextHtml(msg) + documentStr + "<div class=\"chat-timestamp\">" + formattedTime + "</div></div></div></li>"
                $(".append-chat-live").append(str)
                $(".live-chat-user-msg").focus();
                $('.live-chat-body').stop().animate({
                    scrollTop: $(".chat")[0].scrollHeight
                });
                $.ajax({
                    url: "/update_msg",
                    method: 'put',
                    data: { id: id },
                    application: 'json',
                    success: function () {
                    }
                });
            } else if (!(parseInt(current_user) === parseInt(sender)) && isActiveMessagesChat(room_id, sender, receiver, group_chat, current_user)) {
                let docStr = buildChatDocHtmlFromData(docData);
                if (window.maybePrependChatDateSeparator) {
                    window.maybePrependChatDateSeparator(created_at);
                }
                let str = "<table class=\"table-live-chat\"><tr><td class=\"left left-live-chat\" data-msg-id=\"" + id + "\" data-sender-id=\"" + sender + "\" data-msg-date=\"" + msgDateKey + "\">"
                if (group_chat) {
                    let lastSenderId = null;
                    let $lastTd = $('.message-chatting-wrp td[data-sender-id]').last();
                    if ($lastTd.length > 0) {
                        lastSenderId = parseInt($lastTd.attr('data-sender-id'));
                    }
                    if (lastSenderId !== parseInt(sender)) {
                        let capitalizedName = sender_user.charAt(0).toUpperCase() + sender_user.slice(1);
                        str += "<h6>" + capitalizedName + "</h6>"
                    }
                }
                str += "<span class=\"in\"><div class=\"chat-body\"><div class=\"chat-message\">" +
                    window.chatMessageTextHtml(msg) + docStr +
                    "<div class=\"chat-message-meta chat-message-meta--incoming\"><span class=\"chat-message-time\">" + formattedTime + "</span></div></div></div></span></td></tr></table>"
                $(".append-live-message").append(str)
                if (docData && docData.length > 0 && window.appendToGroupInfoMediaFiles) {
                    window.appendToGroupInfoMediaFiles(docData, id);
                }
                $('.message-chatting-wrp').stop().animate({
                    scrollTop: $(".message-chatting-wrp-scroll")[0].scrollHeight
                });
                $(".live-msg-sender-msg").focus();
                $.ajax({
                    url: "/update_msg",
                    method: 'put',
                    data: { id: id },
                    application: 'json',
                    success: function () {
                    }
                });

            } else if ((Array.isArray(data.content.count_chat_user) && data.content.count_chat_user.includes(parseInt(current_user))) || parseInt(receiver) === parseInt(current_user)) {
                // Increment unread count badge in sidebar
                let badge = $(`.unread-count-badge[data-chatbox-id="${room_id}"]`);
                if (badge.length > 0) {
                    let currentCount = parseInt(badge.text()) || 0;
                    badge.text(currentCount + 1).css('display', 'flex');
                }

                // Update nav badge locally — no API call needed.
                // For 1-1 chats: unread_message comes from the broadcast payload.
                // For group chats: unread_message is 0 in the payload, so we add 1 ourselves.
                let addCount = 0;
                if (unread_message > 0) {
                    addCount = parseInt(unread_message);
                } else if (Array.isArray(data.content.count_chat_user) && data.content.count_chat_user.includes(parseInt(current_user))) {
                    addCount = 1;
                }

                if (addCount > 0) {
                    let navVal = parseInt($('#nav-msg-count').text()) || 0;
                    let newVal = navVal + addCount;
                    $('#nav-msg-count').text(newVal);
                    localStorage.setItem('unread_msg_count_' + current_user, newVal);
                    $("#live-msg").removeClass("d-block").addClass("d-none");
                    $("#msg").removeClass("d-none").addClass("d-block");
                }
            }

            if (parseInt(receiver) === parseInt(current_user)) {
                if (unread_message > 0) {
                    let new_message = new Set(count_user);
                    for (let i of new_message) {
                        if (parseInt(i) === parseInt(sender)) {
                            let message_count = parseInt($(`#${i}`).text());
                            if (isNaN(message_count)) {
                                $(`.${i}`).text(1)
                            }
                            else {
                                message_count += 1;
                                $(`.${i}`).text(message_count);
                            }
                        }
                    }
                    if (sender == $(".service-provider-message-count").attr("id")) {
                        let service_provider_message = parseInt($(".service-provider-message-count").text());
                        if (isNaN(service_provider_message)) {
                            service_provider_message = 0;
                        }
                        service_provider_message += 1;
                        $(".service-provider-message-count").text(service_provider_message).show();
                    }
                }
            }

            if (parseInt(receiver) === parseInt(current_user) || (Array.isArray(group_chat_recipients) && group_chat_recipients.includes(parseInt(current_user)))) {
                const hideClient = Array.isArray(client_hide) && client_hide.length > 0 &&
                    !client_hide.map(String).includes(String(current_user)) &&
                    Array.isArray(employees) && employees.includes(parseInt(current_user)) &&
                    parseInt(sender) === parseInt(client);
                if (!hideClient) {
                    var toast = toastr.info("Received new Messages from " + sender_name);

                    toast.on('click', function () {
                        handleToastClick();
                    });

                    const isOnChatPage = window.location.pathname.startsWith('/messages');
                    if (!hasAutoClickedFirstToast && !isOnChatPage) {
                        hasAutoClickedFirstToast = true;

                        setTimeout(() => {
                            const t = $("#toast-container .toast");
                            if (t.length > 0) {
                                t.trigger("click");
                            }
                        }, 50);
                    }

                    function handleToastClick() {
                        $('.live-d').css('display', 'block');
                        $(`.${sender}`).text('');
                        $(`.unread-count-badge[data-chatbox-id="${room_id}"]`).text('0').hide();

                        $.ajax({
                            url: "/live_chat",
                            method: 'get',
                            data: { room_id: room_id, receiverId: sender, read: true },
                            application: 'json',
                            success: function () {
                                $('.live-chat-user-id').val(id);
                                let navVal = parseInt($('#nav-msg-count').text()) || 0;
                                let newVal = Math.max(0, navVal - (parseInt(unread_message) || 1));
                                $('#nav-msg-count').text(newVal > 0 ? newVal : '');
                                // Invalidate localStorage so next page reload gets clean updated count from server
                                localStorage.removeItem('unread_msg_count_' + current_user);
                            }
                        });
                    }

                }
            }
        }
    }
});

// Safety net: the badge/nav counters above are now updated locally (see the
// room_seen and group-message branches) instead of re-fetching from the
// server on every event, to avoid hammering /latest_message_count. Local
// counting can drift (a missed broadcast, another open tab/device), so
// resync from the server once whenever the tab regains focus rather than on
// a timer or per-message basis.
document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    if (current_user === "" || current_user === "undefined" || current_user === undefined) return;
    $.ajax({
        type: 'GET',
        url: '/latest_message_count',
        success: function (data) {
            const count = data.data.unread_message || 0;
            localStorage.setItem('unread_msg_count_' + current_user, count);
            applyUnreadCount(count);
        }
    });
});
